import { render } from "./StatisticsTopProjectsChart.vue?vue&type=template&id=5e01a88c"
import script from "./StatisticsTopProjectsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsTopProjectsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__